import React from 'react';
import Module from 'Components/Core/Module';
import Listing from 'Components/Core/Listing';
import FormElement from 'Components/Core/Form/FormElement';
import DialogForm from 'Components/Core/DialogForm';
import BooleanIcon from 'Components/Core/BooleanIcon';
import './Smilies.css';

export default function Smilies(props) {

    const x = props.x;
	const renderCount = React.useRef(1);
	const wafId = props.id;
	const dialogNewSmileyId = "add-smiley";
	const [disabled, setDisabled] = React.useState(false);
	const [uploading, setUploading] = React.useState(false);
	const fileInputRef = React.useRef(null);

	var lf;

	x.wam.init(props.id, {
		"onClose": () => {
			delete x.waf[wafId];
		}
	})

	x.waf.init(wafId, {
		'onAfterSend': () => {
			loadSmilies();
			x.was.sendSmiliesUpdate();
		}
	})

	React.useEffect(() => {
		if (renderCount.current === 1) {
			loadSmilies();
		}
		renderCount.current++;
		if (x.was.memberLevel > 2) {
			x.waf.disable(wafId, 'code');
			x.waf.disable(wafId, 'image');
			x.waf.disable(wafId, 'reaction');
		}
	});

	function registerListing(listingFunctions) {
		lf = listingFunctions;
	}

	function loadSmilies() {
		x.was.axGet('Backend/webapp.php?module=Posting&task=SmileyList&active=1', handleLoadSmilies);
	}

	function handleLoadSmilies(result) {
		if (result.data['returncode'] === 1) {
			makeSmilies(result.data['content']);
			// setTimeout(loadsmilies, 30000);
		}
		else {
			x.wah.addHint('Fehler beim Lesen der Smilies-Tabelle!', true);
		}

	}

	function makeSmilies(smilies) {
		lf.reset();

		addHeader();

		if (smilies) {
			// memberCount = smilies.length;
			smilies.forEach(
				function (item) {

					// console.log('Online Count: ' + onlineCount);
					addRow(item);
				}
			)
		}

		lf.makeListing();
	}

	function addSmiley() {
		x.waf.setAddSend(wafId, 'originalcode', '');
		x.waf.set(wafId, 'code', '');
		x.waf.set(wafId, 'image', '');
		x.waf.set(wafId, 'reaction', 0);
		x.waf.set(wafId, 'category', '');
		x.waf.hide(wafId, 'message');
		x.wad[dialogNewSmileyId].show(() => { x.waf.focus(wafId, 'code') });
	}

	function editSmiley(code, image, reaction, category) {
		x.waf.setAddSend(wafId, 'originalcode', code);
		x.waf.set(wafId, 'code', code);
		x.waf.set(wafId, 'image', image);
		x.waf.set(wafId, 'reaction', reaction);
		x.waf.set(wafId, 'category', category || '');
		x.waf.hide(wafId, 'message');
		setDisabled(disabled);
		x.wad[dialogNewSmileyId].show(() => { x.waf.focus(wafId, 'code') });
	}

	function uploadImage(file) {
		const code = x.waf.get(wafId, 'code').trim();
		let fileName = x.waf.get(wafId, 'image').trim();
		if (fileName === '' && code === '') {
			x.waf.set(wafId, 'message', 'Bitte zuerst ein Kürzel eingeben!');
			x.waf.show(wafId, 'message');
			return;
		}
		if (fileName === '' || !fileName.includes('.')) {
			const extension = (file.type === 'image/gif') ? 'gif' : (file.type === 'image/jpeg') ? 'jpg' : 'png';
			// Das Kuerzel darf beliebige Zeichen enthalten (z.B. "))"), ein Dateiname aber nicht -
			// daher hier auf dateinamen-sichere Zeichen bereinigen, statt das Kuerzel 1:1 zu uebernehmen.
			const safeBaseName = (fileName !== '' ? fileName : code).replace(/[^A-Za-z0-9_-]/g, '_');
			fileName = (safeBaseName !== '' ? safeBaseName : 'smiley') + '.' + extension;
		}
		setUploading(true);
		const formData = new FormData();
		formData.append('image', file, fileName);
		formData.append('filename', fileName);
		x.was.axPost('Backend/webapp.php?module=Posting&task=UploadSmileyImage', formData, (result) => {
			setUploading(false);
			if (result.data.returncode === 1) {
				x.waf.set(wafId, 'image', result.data.content.fileName);
				x.waf.hide(wafId, 'message');
			}
			else {
				x.waf.set(wafId, 'message', 'Hochladen der Datei fehlgeschlagen!');
				x.waf.show(wafId, 'message');
			}
		});
	}

	function onFileSelected(event) {
		const file = event.target.files[0];
		if (file) uploadImage(file);
		event.target.value = '';
	}

	function onPasteImage(event) {
		const items = [].slice.call(event.clipboardData.items).filter((item) => item.type.indexOf('image') !== -1);
		if (items.length > 0) {
			event.preventDefault();
			uploadImage(items[0].getAsFile());
		}
	}

	function addHeader() {
		lf.addHeader('Smiley');
		lf.addHeader('Kürzel');
		lf.addHeader('Unicode');
		lf.addHeader('Kategorie');
		lf.addHeader('Reaktion');
	}

	function addRow(item) {
		lf.addRow(
			[makeSmiley(item.image, item.unicode), item.code, item.image, (item.unicode === 1) ? (item.category || '-') : 'Eigene', <BooleanIcon value={item.reaction} />],
			item,
			(item.disabled===1) ? 'row-disabled' : '',
			(e, itemClicked) => {
				editSmiley(itemClicked.code, itemClicked.image, itemClicked.reaction, itemClicked.category);
			}
		);
	}

	function makeSmiley(image, unicode) {
		const smiley = (unicode === 0)
		? <img className="smiley" alt="Smiley" src={"Backend/webapp.php?module=Public&task=Image&file=" + image}/>
		: <i className="unicode-smiley" >{image.split(',').map(cp => String.fromCodePoint(parseInt(cp.trim()))).join('')}</i>;
		return smiley;
	}
	function remove(code) {
		x.was.axPost("Backend/webapp.php?module=Posting&task=DeleteSmiley&", { "code": code }, (result) => {
			// console.log(result.data['returncode']);
			if (result.data['returncode'] === 1) {
				loadSmilies();
				x.was.sendSmiliesUpdate();
				x.wad[dialogNewSmileyId].hide();
			}
			else {
				x.waf.set(wafId, 'message', 'Löschen des Smileys nicht möglich!');
				x.waf.show(wafId, 'message');
			}
		})
	}

	const moduleToolbar =
		(x.was.memberLevel < 3)
			?
			<span className={` bi bi-plus-square module-icon  `} title="Neues Smiley hinzufügen" onClick={() => addSmiley()}>
			</span>
			: null;

	const formFields =
		<React.Fragment>
			<FormElement type="text"
				x={x}  
				dialogId={dialogNewSmileyId}
				wafId={wafId}
				id="code"
				mandatory={true}
				title="Kürzel"
				fieldValue=""
				maxLength="20"
			/>
			<FormElement type="text"
				x={x}
				dialogId={dialogNewSmileyId}
				wafId={wafId}
				id="image"
				mandatory={true}
				title="Unicode (Dezimalwert, ggf. mehrere durch Komma) oder Dateiname"
				fieldValue=""
				maxLength="30"
				onPaste={onPasteImage}
			>
				<button type="button" className="btn btn-sm smiley-upload-button" disabled={uploading} onClick={() => fileInputRef.current.click()}>
					<i className="bi bi-upload"></i>{uploading ? 'Lädt hoch...' : 'Datei hochladen'}
				</button>
				<input type="file" accept="image/png,image/gif,image/jpeg" ref={fileInputRef} className="d-none" onChange={onFileSelected} />
				<div className="smiley-upload-hint">Datei auswählen, per Zwischenablage einfügen (Strg/Cmd+V im Feld) oder Dateinamen einer bereits vorhandenen Datei eintragen.</div>
			</FormElement>
			<FormElement type="text"
				x={x}
				dialogId={dialogNewSmileyId}
				wafId={wafId}
				id="category"
				mandatory={false}
				title="Kategorie (nur für Unicode-Smilies, optional)"
				fieldValue=""
				maxLength="50"
			/>
			<FormElement type="checkbox" x={x} wafId={wafId} id="reaction" title="Als Reaktion verfügbar" />
		</React.Fragment>

	const buttons = [];
	if (x.was.memberLevel === 1) {
		buttons.push(
			<button 
				type="button" 
				key="delete" 
				className={`btn ${(disabled) ? 'd-none' : ''}`} 
				onClick={() => {remove(x.waf.get(wafId, 'code'))} } 
			>
				Löschen
			</button>);
	}

	return (
		<Module
			id={props.id}
			x={x}
			classes={`module-smilies `}
			title={props.title}
			display="d-block"
			onShow={loadSmilies}
			titleToolbar={
				<span>
					{moduleToolbar}
				</span>
			}
		>
			<Listing id="smilies-listing" x={x} registerListing={registerListing} classes="listing smiley-list" noTitle={false} />
			<DialogForm
				id={dialogNewSmileyId}
				x={x}
				wafId={wafId}
				title="Smiley bearbeiten"
				classes="dialog-new-smiley"
				children={formFields}
				module="Posting"
				sendTask="SaveSmiley"
				sendButton={(x.was.memberLevel < 3) ? true : false}
				buttons={buttons}
			/>
		</Module>
	)


};

